module.exports = __webpack_public_path__ + "img/chat.78bc8eec.png";